<template>
  <v-container fluid>
    <member-list/>
  </v-container>
</template>

<script>
  export default {
    name: 'Members',
    components: {
      MemberList: () => import ('@/components/member/MemberList.vue')
    },
  }
</script>

<style lang="scss" scoped>

</style>